import { BoxChecked, BoxEmpty, BoxMinus } from 'pcln-icons';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { applyVariations, getPaletteColor } from '../utils/utils';
const CheckBoxWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Checkbox__CheckBoxWrapper",
  componentId: "sc-1vxg344-0"
})(["display:inline-flex;align-items:center;position:relative;vertical-align:middle;padding:2px;cursor:", ";background-color:inherit;color:", ";svg{border:1px solid transparent;border-radius:4px;padding:2px;}svg[data-name='checked']{display:none;}svg[data-name='indeterminate']{display:none;}~ span{cursor:", ";}> input[data-indeterminate='true']{& ~ svg[data-name='indeterminate']{display:inline-block;color:", ";}&:hover ~ svg[data-name='indeterminate']{color:", ";}& ~ svg[data-name='empty']{display:none;}& ~ svg[data-name='checked']{display:none;}}> input:not([data-indeterminate='true']){& ~ svg[data-name='empty']{color:", ";}&:focus-visible ~ svg{border:1px solid ", ";background-color:", ";}}> input:checked:not([data-indeterminate='true']){& ~ svg[data-name='checked']{display:inline-block;color:", ";}& ~ svg[data-name='empty']{display:none;}&:focus-visible ~ svg{border:1px solid ", ";background-color:", ";}&:hover ~ svg[data-name='checked']{color:", ";}}> input:hover ~ svg[data-name='empty']{color:", ";}", ""], ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', props => props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('border.dark')(props), ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', props => props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('base')(props), props => props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('dark')(props), props => props.disabled ? getPaletteColor('border.base') : getPaletteColor(props.unselectedColor), getPaletteColor('border.base'), getPaletteColor('background.light'), props => props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('base')(props), getPaletteColor('base'), getPaletteColor('light'), props => props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('dark')(props), props => props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('base')(props), applyVariations('Checkbox'));
const StyledInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "Checkbox__StyledInput",
  componentId: "sc-1vxg344-1"
})(["appearance:none;opacity:0;position:absolute;z-index:0;"]);
/**
 * @public
 */
export const Checkbox = React.forwardRef(({
  checked,
  color = 'primary',
  disabled,
  size = 20,
  indeterminate = false,
  unselectedColor = 'text.light',
  onChange,
  defaultChecked,
  ...props
}, ref) => {
  const [showIndeterminate, setShowIndeterminate] = useState(indeterminate && !defaultChecked);
  function handleChange(e) {
    setShowIndeterminate(false);
    if (typeof onChange === 'function') {
      onChange(e);
    }
  }
  useEffect(() => {
    setShowIndeterminate(indeterminate);
  }, [indeterminate]);
  // Add 4px to Icon's height and width to account for size reduction caused by adding padding to SVG element
  const borderAdjustedSize = size + 4;
  return React.createElement(CheckBoxWrapper, {
    color: color,
    disabled: disabled,
    unselectedColor: unselectedColor
  }, React.createElement(StyledInput, {
    type: 'checkbox',
    checked: checked,
    color: color,
    disabled: disabled,
    size: size,
    indeterminate: indeterminate,
    unselectedColor: unselectedColor,
    defaultChecked: defaultChecked,
    ...props,
    onChange: handleChange,
    role: 'checkbox',
    "aria-checked": showIndeterminate ? 'mixed' : checked,
    "data-indeterminate": showIndeterminate,
    ref: ref
  }), React.createElement(BoxChecked, {
    size: borderAdjustedSize,
    "data-name": 'checked'
  }), React.createElement(BoxMinus, {
    size: borderAdjustedSize,
    "data-name": 'indeterminate'
  }), React.createElement(BoxEmpty, {
    size: borderAdjustedSize,
    "data-name": 'empty'
  }));
});
Checkbox.displayName = 'Checkbox';